export default __webpack_public_path__ + "img/25cabe6dbca4a57a06962a2c40aa7bdb.png";